__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "contacts";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@comagic/core", "v1.26.3", () => (Promise.all([__webpack_require__.e(48766), __webpack_require__.e(44914), __webpack_require__.e(9354)]).then(() => (() => (__webpack_require__(48766))))));
			register("@comagic/workplace-utils", "v1.15.1", () => (Promise.all([__webpack_require__.e(40724), __webpack_require__.e(32146), __webpack_require__.e(14414)]).then(() => (() => (__webpack_require__(32146))))));
			register("axios", "0.27.2", () => (__webpack_require__.e(72505).then(() => (() => (__webpack_require__(72505))))));
			register("classnames", "2.3.2", () => (__webpack_require__.e(32485).then(() => (() => (__webpack_require__(32485))))));
			register("formik", "2.4.6", () => (Promise.all([__webpack_require__.e(7425), __webpack_require__.e(44914)]).then(() => (() => (__webpack_require__(7425))))));
			register("history", "5.3.0", () => (__webpack_require__.e(57971).then(() => (() => (__webpack_require__(57971))))));
			register("mobx-react-lite", "3.4.3", () => (Promise.all([__webpack_require__.e(44914), __webpack_require__.e(59676), __webpack_require__.e(86672), __webpack_require__.e(15824)]).then(() => (() => (__webpack_require__(93443))))));
			register("mobx-state-tree", "5.4.2", () => (Promise.all([__webpack_require__.e(59676), __webpack_require__.e(50346)]).then(() => (() => (__webpack_require__(50346))))));
			register("mobx", "6.12.4", () => (__webpack_require__.e(27813).then(() => (() => (__webpack_require__(27813))))));
			register("nanoid", "3.3.7", () => (__webpack_require__.e(43561).then(() => (() => (__webpack_require__(43561))))));
			register("qs", "6.13.0", () => (__webpack_require__.e(55373).then(() => (() => (__webpack_require__(55373))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(40961), __webpack_require__.e(44914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-hook-form", "7.46.1", () => (Promise.all([__webpack_require__.e(49785), __webpack_require__.e(44914)]).then(() => (() => (__webpack_require__(49785))))));
			register("react-intl", "6.6.8", () => (Promise.all([__webpack_require__.e(12598), __webpack_require__.e(44914)]).then(() => (() => (__webpack_require__(12598))))));
			register("react-router-dom", "6.9.0", () => (Promise.all([__webpack_require__.e(47767), __webpack_require__.e(84976), __webpack_require__.e(44914)]).then(() => (() => (__webpack_require__(84976))))));
			register("react", "18.3.1", () => (__webpack_require__.e(96540).then(() => (() => (__webpack_require__(96540))))));
			register("yup", "0.32.11", () => (Promise.all([__webpack_require__.e(87527), __webpack_require__.e(20627)]).then(() => (() => (__webpack_require__(20627))))));
			initExternal(78995);
			initExternal(86751);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};